import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "evil-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('lunatic.seoHeading')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "lunatic" }),
    _createVNode(_component_TopRolePlayer, {
      role: "lunatic",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('lunatic.generalTipsHeader')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('lunatic.strategicFailure')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('lunatic.strategicFailureDetails')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('lunatic.deceiveWithBluff')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('lunatic.bluffTechnique')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('lunatic.covertSupportAllies')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('lunatic.subtleAlignment')), 1)
      ])
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}